<div
  fxLayout="row"
  fxLayout.xs="column"
  style="height: 100%; min-height: 500px"
>
  <as-split direction="horizontal">
    <as-split-area size="30">
      <div fxLayout="column" fxLayout.xs="column">
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <h6 id="heading">Role List</h6>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row">
            <mat-tree
              #tree
              [dataSource]="dataSource"
              [(treeControl)]="treeControl"
            >
              <mat-tree-node
                class="site-mat-tree-node"
                *matTreeNodeDef="let node"
                matTreeNodeToggle
                matTreeNodePadding
              >
                <button
                  id="userRoles"
                  type="button"
                  (click)="$event.preventDefault()"
                  bciprimarybutton
                  disabled
                ></button>
                <mat-checkbox
                  class="checklist-leaf-node"
                  id="chkRole_{{ node.roleId }}"
                  [checked]="checklistSelection.isSelected(node)"
                  (click)="onCheckedNodeChange(node, false, $event)"
                  >{{ node.name }}</mat-checkbox
                >
              </mat-tree-node>
              <mat-tree-node
                class="site-mat-tree-node"
                *matTreeNodeDef="let node; when: hasChild"
                matTreeNodePadding
              >
                <button
                  id="roleNames"
                  type="button"
                  (click)="$event.preventDefault()"
                  bciprimarybutton
                  matTreeNodeToggle
                  [attr.aria-label]="'toggle ' + node.filename"
                >
                  <mat-icon
                    *ngIf="treeControl.isExpanded(node)"
                    fontIcon="Bosch-Ic-arrow-expand-down"
                  ></mat-icon>
                  <mat-icon
                    *ngIf="!treeControl.isExpanded(node)"
                    fontIcon="Bosch-Ic-arrow-expand-right"
                  ></mat-icon>
                </button>
                <mat-checkbox
                  class="checklist-leaf-node"
                  id="chkRole_{{ node.roleId }}"
                  [checked]="checklistSelection.isSelected(node)"
                  (click)="onCheckedNodeChange(node, true, $event)"
                  >{{ node.name }}</mat-checkbox
                >
              </mat-tree-node>
            </mat-tree>
          </div>
        </mat-expansion-panel>
      </div>
    </as-split-area>
    <as-split-area size="70">
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h6 id="add-edit-role-heading">Add/Edit Role</h6>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <br />
        <div class="row" style="padding-bottom: 16px">
          <div class="col-md-12">
            <button
              id="editRole"
              class="button-primary"
              bciprimarybutton
              [disabled]="isDisabledEditBtn"
              (click)="edit($event)"
            >
              <span>
                <mat-icon
                  aria-hidden="false"
                  aria-label="weather icon"
                  class="bosch-ic-edit"
                  style="width: max-content"
                ></mat-icon>
              </span>
            </button>
            &nbsp;
            <button
              id="addRole"
              class="button-primary"
              bciprimarybutton
              [disabled]="isDisabledAddBtn"
              (click)="add($event)"
            >
              <span>
                <mat-icon
                  aria-hidden="false"
                  aria-label="weather icon"
                  class="bosch-ic-add"
                  style="width: max-content"
                ></mat-icon>
              </span>
            </button>
            &nbsp;
            <button
              id="deleteRole"
              class="button-primary"
              bciprimarybutton
              [disabled]="isDisabledDeleteBtn"
              (click)="delete($event)"
            >
              <span>
                <mat-icon
                  aria-hidden="false"
                  aria-label="weather icon"
                  class="bosch-ic-delete"
                  style="width: max-content"
                ></mat-icon>
              </span>
            </button>
          </div>
        </div>
        <div class="row">
          <form
            [formGroup]="formData"
            #formDirective="ngForm"
            (ngSubmit)="submit()"
            novalidate
          >
            <div class="col-md-9">
              <div class="row">
                <div class="col-md-4">
                  <mat-label class="label-input pull-right"
                    >Role Name: <span class="iep-required">*</span></mat-label
                  >
                </div>
                <div class="col-md-8">
                  <mat-form-field>
                    <input
                      [(ngModel)]="model.name"
                      matInput
                      placeholder="Enter Role Name"
                      formControlName="roleNameCtr"
                      ngDefaultControl
                      required
                    />
                    <mat-error
                      *ngIf="isFieldHasError('roleNameCtr', 'required')"
                      >This field is required.</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="row" style="padding-bottom: 16px">
                <div class="col-md-4">
                  <mat-label class="label-input pull-right"
                    >Definition:</mat-label
                  >
                </div>
                <div class="col-md-8">
                  <textarea
                    rows=""
                    cols=""
                    class="form-control"
                    placeholder="Enter Definition"
                    ngDefaultControl
                    formControlName="definitionCtr"
                    [(ngModel)]="model.definition"
                    maxlength="300"
                  ></textarea>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <mat-label class="label-input pull-right"
                    >Allowed Site Selection Number:
                    <span class="iep-required">*</span></mat-label
                  >
                </div>
                <div class="col-md-8">
                  <mat-form-field>
                    <mat-select
                      [(ngModel)]="model.allowedSiteSelectionNumber"
                      ngDefaultControl
                      formControlName="allowedSiteSelectionNumberCtr"
                    >
                      <mat-option
                        *ngFor="let item of allowedSiteSelectionNumber"
                        [disabled]="item.disabled"
                        [value]="item.value"
                        >{{ item.name }}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="
                        isFieldHasError(
                          'allowedSiteSelectionNumberCtr',
                          'required'
                        )
                      "
                      >This field is required.</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="row pull-right">
                <br />
                <div class="col-md-12">
                  <button
                    id="submitRole"
                    class="button-primary"
                    bciprimarybutton
                    type="submit"
                    [disabled]="!formData.valid"
                  >
                    <span>
                      <mat-icon
                        aria-hidden="false"
                        aria-label="weather icon"
                        class="bosch-ic-checkmark-frame"
                        style="width: max-content"
                      ></mat-icon>
                    </span>
                    Save
                  </button>
                  &nbsp;
                  <button
                    id="cancel"
                    bciprimarybutton
                    class="button-primary"
                    [disabled]="isDisabledCancelBtn"
                    (click)="reset($event)"
                  >
                    <span>
                      <mat-icon
                        aria-hidden="false"
                        aria-label="weather icon"
                        class="bosch-ic-abort-frame"
                        style="width: max-content"
                      ></mat-icon>
                    </span>
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <ng-container>
          <hr />
          <div class="row">
            <div class="col-md-3" style="display: flex; align-items: center">
              <mat-label class="label-input">Features:</mat-label>
              <mat-label class="label-input">{{ selectedFeatures }}</mat-label>
            </div>
            <div class="col-md-5" style="display: flex; align-items: center">
              <mat-label>Modification type:</mat-label>
              &nbsp;
              <mat-form-field>
                <mat-label>Select role</mat-label>
                <mat-select
                  [(ngModel)]="selectedModificationType"
                  (ngModelChange)="onModificationTypeChange()"
                  ngDefaultControl
                >
                  <mat-option
                    *ngFor="let item of modificationType"
                    [value]="item.value"
                    >{{ item.name }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <div
              class="col-md-4"
              style="
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-top: 10px;
              "
            >
              <mat-form-field>
                <input
                  matInput
                  type="text"
                  ngDefaultControl
                  (keyup)="search($event.target.value)"
                  placeholder="Filter by Feature Name"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <mat-table #tableFeature [dataSource]="featuresDataSource" matSort>
              <ng-container matColumnDef="index">
                <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
                <mat-cell *matCellDef="let item; let rindex = index">{{
                  rindex + 1
                }}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="selected">
                <mat-header-cell *matHeaderCellDef>Select</mat-header-cell>
                <mat-cell *matCellDef="let item">
                  <mat-checkbox
                    [(ngModel)]="item.selected"
                    [checked]="item.selected"
                    [disabled]="isDisableSeleted"
                    (change)="onChangeFeature()"
                  ></mat-checkbox>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="modificationTypeString">
                <mat-header-cell *matHeaderCellDef
                  >Modification Type</mat-header-cell
                >
                <mat-cell *matCellDef="let item">{{
                  item.modificationTypeString
                }}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef
                  >Feature Name</mat-header-cell
                >
                <mat-cell *matCellDef="let item">{{ item.name }}</mat-cell>
              </ng-container>
              <mat-header-row
                *matHeaderRowDef="displayedColumns"
              ></mat-header-row>
              <mat-row
                *matRowDef="let item; columns: displayedColumns"
              ></mat-row>
            </mat-table>
            <mat-paginator
              #paginator
              [pageSize]="5"
              [pageSizeOptions]="[5, 10, 20]"
            >
            </mat-paginator>
          </div>
        </ng-container>
      </mat-expansion-panel>
    </as-split-area>
  </as-split>
</div>
